import home from '../views/home2/index.vue'
// 通用模块路由
const common = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      name: 'home',
      module: 'home'
    },
    component: home
  }
]
export const microApp = [
  {
    name: 'otapubtrip',
    entry: '/m/otapub/trip',
    activeRule: ['/otapubtrip/', '/mg/otapubtrip']
  },
  {
    name: 'otapub',
    entry: '/m/otapub/app',
    activeRule: ['/otapub/', '/mg/otapub']
  },
  {
    name: 'flight',
    entry: '/m/flight/app',
    activeRule: ['/flight/', '/mg/flight']
  },
  {
    name: 'hotel',
    entry: '/m/hotel/app',
    activeRule: ['/hotel/', '/mg/hotel']
  },
  {
    name: 'train',
    entry: '/m/train/web',
    activeRule: ['/train/', '/mg/train']
  },
  {
    name: 'car',
    entry: '/m/car/web',
    activeRule: ['/car/', '/mg/car']
  },
  {
    name: 'expense',
    entry: '/m/expense',
    activeRule: ['/expense/', '/mg/expense']
  },
  {
    name: 'subsidy',
    entry: '/m/bi/subsidy/app',
    activeRule: ['/subsidy/', '/mg/bi/subsidy']
  },
  {
    name: 'plan',
    entry: '/m/control/plan',
    activeRule: ['/plan/', '/mg/control/plan']
  },
  {
    name: 'rewardPoints',
    entry: '/resource/rewardPoints',
    activeRule: ['/reward/', '/mg/reward']
  },
  {
    name: 'liquidation',
    entry: '/m/oper/liquidation',
    activeRule: ['/mg/oper/liquidation/']
  },
  {
    name: 'appwxm',
    entry: '/resource/appwxm',
    activeRule: ['/appwxm']
  },
  {
    name: 'common',
    entry: '/m/pp/common',
    activeRule: ['/']
  }
]

const microAppRouter = microApp
  .map((item) =>
    item.activeRule.map((it) => {
      return {
        meta: {
          name: item.name,
          entry: item.entry
        },
        path: it + ':pathMatch(.*)*',
        component: () => import('./microApp/index.vue')
      }
    })
  )
  .flat()
export default common.concat(microAppRouter)
